import PrintService from "@/services/Print.js"
import Vue from "vue";


const state = {
    products: [],

    /*
    Per ora prevedo una sola variant option per il formato. Se un giorno avremo più varianti,
    dovrò utilizzare un array di optionId
    */
    selectedProductId: null,
    selectedProductVariantOptionFormat: null,

    // PhotoChooser
    photoChooserOpen: false,
    photoChooserMultipleSelection: true,
    photoChooserInitialSelectedIds: [],
    photoChooserInitialPicaCode: null
}


const getters = {
    isPhotoChooserOpen: state => state.photoChooserOpen === true,
    isProductSelected: state => state.selectedProductId !== null,  // TODO: aggiungere && state.selectedProductVariantOptionsIds.length
    getSelectedProduct: state => state.products.find(product => product.id === state.selectedProductId),
    getProductById: state => id => state.products.find(product => product.id === id),
    productsByFamily: state => familyId => state.products.filter(product => product.family_id === familyId),
    // hasPhotoChooserInitialIds: state => state.photoChooserInitialSelectedIds.length > 0,
    getProductTitle: state => printItem => {
        const variantOptionFormat = printItem.product_variant_options[0]
        return printItem.product ? `${printItem.product.title} ${variantOptionFormat.name}` : ''
    }
}


const mutations = {
    SET_PRODUCTS (state, products) {
        state.products = products
    },

    SET_PRODUCT_SELECTED (state, productData) {
        state.selectedProductId = productData.productId
        state.selectedProductVariantOptionFormat = productData.productVariantOptionFormat
    },

    RESET_PRODUCT_SELECTED (state) {
        state.products = []
        state.selectedProductId = null
        state.selectedProductVariantOptionFormat = null
    },

    // SET_PRODUCT_SELECTED (state, productId) {
    //     state.productSelectedId = productId
    // },

    SET_PHOTO_CHOOSER_INITIAL_PICACODE (state, picacode) {
        state.photoChooserInitialPicaCode = picacode
    },

    OPEN_PHOTO_CHOOSER (state, {multipleSelection, initialSelectedIds}) {
        state.photoChooserOpen = true
        if (multipleSelection !== undefined) {
            state.photoChooserMultipleSelection = multipleSelection
        }
        state.photoChooserInitialSelectedIds = initialSelectedIds || []
    },

    CLOSE_PHOTO_CHOOSER (state) {
        state.photoChooserOpen = false
        state.photoChooserInitialPicaCode = null
    },
}


const actions = {
    getProducts(context) {
        return PrintService.getProducts()
            .then(response => {
                context.commit('SET_PRODUCTS', response.data)
                return response
            })
            .catch(function(error) {
                return error
            })
    },

    // eslint-disable-next-line
    getPrintItemProductConfigurationBody(context, printItem) {
        // ogni componente sa come costruire il body per la sua product family
        // TODO: declinato solo per le prints!
        //const printItem = rootGetters['cart/getPrintItemById'](printItemId)
        //console.log('printItem', printItem)

        let body = {
            'product_id': printItem.product_id,
            'variant_option_ids': printItem.variant_option_ids,
            'product_configuration': {
                'photos': []
            }
        }

        printItem.photos.forEach(item => {
            body.product_configuration.photos.push({
                'photo_id': item.photo.id,  // non uso photoId perchè è una stringa e la chiamata
                'quantity': item.quantity,
            })
        })

        return Promise.resolve(body)
    },
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
